import React, { useState, useEffect } from 'react';
import { Row } from 'reactstrap';
import EditEventCard from '../Card/EditEventCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports'
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json'
import { useLocation } from "react-router";
import CreateEvent from '../Card/CreateEvent';
import PopUp from './PopUp'
import EditNewQuestions1 from '../EditNewQuestions1'
import DeleteEvent from './DeleteEvent'
import ReOpenAssignment from './ReOpenAssignment'
import { cx } from '@emotion/css';
import * as styles from './createChallenges.style';
import * as assignmentStyles from '../assignments/assignments.style';
import createChallengesHeroImg from '../../assets/gen_images/create_challenges_hero.png';
import batchImg from '../../assets/images/challenge-banner.png';
import BorderGlow from '../BorderGlow/BorderGlow';

Amplify.configure(config)

function CreateEvents(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenquestion, setIsOpenquestion] = useState(false);
  const [isShowDeleteEvent, setIsShowDeleteEvent] = useState(false);
  const [isReopenAssignment, setisReopenAssignment] = useState(false);

  const [events, set_events] = useState([]);
  const [addevents, set_addevents] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);
  const [eventname, set_eventname] = useState("");
  const [eventid, set_eventid] = useState("");
  const [event_category, set_event_category] = useState("");

  const [specificcategory, set_specificcategory] = useState([]);
  const [levels, set_levels] = useState([]);
  const [limits, set_limits] = useState([]);
  const [eventdisplay, set_eventdisplay] = useState("");
  const [category, set_category] = useState("");

  let data1 = useLocation();

  function togglePopup() {
    setIsOpen(!isOpen);
  }

  function AddEvent() {
    setIsOpen(!isOpen);
  }

  function computeAnswer(eventname) {
    setIsOpen(!isOpen);
    set_events([{}])
    getToken()
  }

  function completedeletion(eventname) {
    setIsShowDeleteEvent(!isShowDeleteEvent)
    set_events([{}])
    getToken()
  }

  function addquestions(eventname) {
    setIsOpenquestion(!isOpenquestion)
  }

  function closeeditquestionswindow() {
    setIsOpenquestion(!isOpenquestion)
  }

  function showeditquestions(specificcategory, levels, limits, eventdisplay, category) {
    set_specificcategory(specificcategory)
    set_levels(levels)
    set_limits(limits)
    set_eventdisplay(eventdisplay)
    set_category(category)
    setIsOpenquestion(!isOpenquestion)
  }

  function showdeleteevents2(id, eventname, category) {
    set_eventname(eventname)
    set_event_category(category)
    set_eventid(id)
    setIsShowDeleteEvent(!isShowDeleteEvent)
  }

  function showReOpenAssignment(id, eventname, category) {
    set_eventname(eventname)
    set_event_category(category)
    set_eventid(id)
    setisReopenAssignment(!isReopenAssignment)
  }

  function closedeleteeventwindow() {
    setIsShowDeleteEvent(!isShowDeleteEvent)
  }

  function closereopeneventwindow() {
    setisReopenAssignment(!isReopenAssignment)
  }

  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();
      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();
        if (user.username.includes("Google_")) {
          getEventsfromDB(user.attributes['email'], jwt);
        } else {
          getEventsfromDB(user.username, jwt);
        }
      });
    } catch (error) {
      Auth.signOut();
    }
  };

  const getEventsfromDB = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      body: JSON.stringify({ 'username': username })
    };
    const response = await fetch(`https://api.quizwizard.net/quiz/listeventsbyowner`, requestOptions)
    const data = await response.json();
    var i, j;
    var loopData = []
    var count = 0
    for (i = 0; i < data.length; i++) {
      for (j = 0; j < data[i]['events'].length; j++) {
        loopData[count] = data[i]['events'][j]
        count = count + 1
      }
    }
    set_events(loopData)
    set_loadedevents(true)
  };

  useEffect(() => {
    getToken();
    set_addevents([{ "id": 1, "category": "Create New Challenge", "count": 6 }])
    document.title = 'Create Challenges | QuizWizard';
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div className={cx(styles.pageWrapper)}>


      <div className="container">
        <h2 className={cx(styles.sectionHeading)} style={{ marginTop: '2.5rem' }}>Manage Your Challenges</h2>

        {loadedevents ? (
          <div className={cx(assignmentStyles.challengeGrid)}>
            {addevents.map(eventcategory => (
              <div key="create-card">
                {isOpen && <PopUp handleClose={togglePopup} selected={answer => computeAnswer(answer)} />}
                {isOpenquestion && (
                  <EditNewQuestions1
                    addquestions={answer => addquestions(answer)}
                    closeeditquestionswindow={closeeditquestionswindow}
                    specificcategory={specificcategory}
                    levels={levels}
                    limits={limits}
                    eventdisplay={eventdisplay}
                    category={category}
                  />
                )}
                <BorderGlow
                  borderRadius={20}
                  backgroundColor="#f6f8fb"
                  glowColor="25 80 50" // Orange-ish glow
                  glowRadius={30}
                  glowIntensity={1.2}
                  colors={['#f16602', '#f4cb0e', '#db692f']}
                  className={cx(assignmentStyles.glowWrapper)}
                >
                  <div className={cx(assignmentStyles.challengeCardGlow)} style={{ pointerEvents: 'auto' }}>
                    <CreateEvent 
                      imgsrc={batchImg} 
                      title="Algebra" 
                      key="create-event-btn" 
                      eventcategory={eventcategory} 
                      target="events"
                      onclick={() => AddEvent()} 
                    />
                  </div>
                </BorderGlow>
              </div>
            ))}

            {events.map(event => (
              <div key={event.id}>
                {isShowDeleteEvent && (
                  <DeleteEvent
                    closedeleteevents={answer => completedeletion(answer)}
                    closedeleteeventwindow={closedeleteeventwindow}
                    category={event_category}
                    eventid={eventid}
                    name={eventname}
                  />
                )}

                {isReopenAssignment && (
                  <ReOpenAssignment
                    ReopenAssignment={answer => completedeletion(answer)}
                    closereopeneventwindow={closereopeneventwindow}
                    category={event_category}
                    eventid={eventid}
                    name={eventname}
                  />
                )}
                <BorderGlow
                  borderRadius={20}
                  backgroundColor="#f6f8fb"
                  glowColor="25 80 50" // Orange-ish glow
                  glowRadius={30}
                  glowIntensity={1.2}
                  colors={['#f16602', '#f4cb0e', '#db692f']}
                  className={cx(assignmentStyles.glowWrapper)}
                >
                  <div className={cx(assignmentStyles.challengeCardGlow)} style={{ pointerEvents: 'auto' }}>
                    <EditEventCard 
                      imgsrc={batchImg} 
                      title="Algebra" 
                      key={event.id} 
                      levels={event.levels} 
                      totalquestions={event.totalquestions} 
                      event={event} 
                      category={data1.state} 
                      target="" 
                      showeditquestions={(specificcategory, levels, limits, eventdisplay, category) => showeditquestions(specificcategory, levels, limits, eventdisplay, category)} 
                      ReopenAssignment={(id, answer, category) => showReOpenAssignment(id, answer, category)} 
                      showdeleteevents={(id, answer, category) => showdeleteevents2(id, answer, category)} 
                    />
                  </div>
                </BorderGlow>
              </div>
            ))}
          </div>
        ) : (
          <div className={cx(styles.loaderWrapper)}>
            <Lottie options={defaultOptions} height={200} width={200} />
          </div>
        )}
      </div>
    </div>
  );
}

export default CreateEvents;

